@if (loadingProgress(); as loadingProgress) {
  <app-linear-progress-bar
    [progress]="loadingProgress"
    @replacementAnimation
  ></app-linear-progress-bar>
}
<router-outlet></router-outlet>
